/**
 * @module Helper
 */

import { Component, ViewChild } from '@angular/core';
import { HelperComponent } from '../helper/helper.component';

@Component({
  selector: 'app-helper-formula',
  templateUrl: './helper-formula.component.html',
  styleUrls: ['./helper-formula.component.css']
})
export class HelperFormulaComponent  {

  @ViewChild('helper', { static: true }) modal: HelperComponent;

  constructor() {}

  public show() {
    this.modal.show();
  }

  public hide() {
    this.modal.hide();
  }

}